import React from 'react';
import {Image, PageHeader} from 'antd';

const Calendar = () => {
    return (
        <>
            <PageHeader
                className="site-page-header"
                title="Календарь"
            />
            <h3>Календарь - дополнительный вид для просмотра данных</h3><br/>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601227388/documentation/Screenshot_2020-09-27_at_20.22.22_eclnwk.png"
            /><br/><br/>
            <h3>В панели управления справа можно выбирать нужный месяц/год</h3><br/>
            <Image
                width={400}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601207927/docs/Screenshot_2020-09-27_at_14.56.47_l40tp3.png"
            /><br/><br/>
            <p>В календаре отображаются названия задач, при клике на конкретную задачу появляется модальное окно с более подробной информацией</p><br/>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601207926/docs/Screenshot_2020-09-27_at_14.56.16_xnlfce.png"
            /><br/><br/>
            <p>В мобильной версии календаря отображается количество задач в день, при клике на этот день список задач выводится снизу</p><br/>
            <Image
                width={400}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601227389/documentation/Screenshot_2020-09-27_at_20.22.53_amvqcy.png"
            />
        </>
    );
};

export default Calendar;